<div class="flex flex-column gap-2">
  <ng-container *ngFor="let s of rows">
    <app-course-unit-section-content-item
      [item]="s"
      [fireActions]="fireActions"
    ></app-course-unit-section-content-item>
  </ng-container>
</div>
